import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom'; //React route//GifLoader
import { Typography, Box, useTheme, Stack } from '@mui/material'; //Se importan elementos de la librería material-ui

import {
  fileActions,
  workflowActions,
  addTitleLegoCurrent,
  documentsActions,
} from '../../store/actions'; //Acciones para redux
import { useStyles } from './LifeTestStyles';
import {
  CustomLoadingOverlay,
  CustomCameraSelfie,
  CustomAlertDialog,
  UseImage,
  GenericContainer,
  Buttons,
  Alert,
} from '../../components';
import { blobToBase64, coreFunctions, GenerateRandom } from '../../utils'; //Acciones para redux
import { documentsRequestsAsync } from '../../services/DocumentsRequestsAsync';
import LifeTestHelp from './LifeTestHelp.js';
import { useTranslation } from 'react-i18next';

const sentimientosArray = [
  // {
  //     value: 'anger',
  //     sentimiento: 'Enojo',
  //     uid: 'eafb0009-241f-40d3-826a-026f0ce9a52f',
  // },
  // {
  //     value: 'fear',
  //     sentimiento: 'Miedo',
  //     uid: '7f6db9f3-b230-4f32-9ffa-0f5ccb7be826',
  // },
  {
    value: 'happiness',
    sentimiento: 'Felicidad',
    uid: 'ec2c2a2c-2666-4574-917c-3fbc30a9d460',
  },
  // {
  //     value: 'disgust',
  //     sentimiento: 'Asco',
  //     uid: '19e291df-5174-41d4-b7b5-ce416d10d657',
  // },
  {
    value: 'surprise',
    sentimiento: 'Sorpresa',
    uid: 'c2faac89-9b73-476e-bf5c-e750620b21a8',
  },
  // {
  //     value: 'sadness',
  //     sentimiento: 'Tristeza',
  //     uid: '6d4e4ed5-9d42-4916-969f-d94a2c7a2353',
  // }
];

export default function LifeTestComponent(props) {
  const theme = useTheme();
  //  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [loadView, setLoadView] = useState(false); //Se muestra/oculta el gif loader
  const localStyles = useStyles(); //estílos de este componente (LoginStyles.js)
  const navigate = useNavigate(); //Módulo "History" de react router
  const location = useLocation();
  const valRandom = GenerateRandom();
  const date = new Date();

  const isMobile =
    navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/Android/i) ? true : false;
  // console.log("isMobile: ", isMobile)
  //usar camara de dispositivo
  const [currentPicture, setCurrentPicture] = useState(null);
  const [activeCargaInicial, setActiveCargaInicial] = useState(false);
  const [fileId, setFileId] = useState(0);
  const [captureInit, setCaptureInit] = useState(null);
  const [cameraB64, setCameraB64] = useState(null);

  const [timerSeconds, setTimerSeconds] = useState(null);
  const [faceResponse, setFaceResponse] = useState();
  const [arraySelfie, setArraySelfie] = useState([]);
  const [validateResponse, setValidateResponse] = useState(null);
  const [valueSentimiento, setValueSentimiento] = useState(null);
  const [disabledButtonCapture, setDisabledButtonCapture] = useState(false);

  const [openAlertInformation, setOpenAlertInformation] = useState(false);
  const [openHelpSelfie, setOpenHelpSelfie] = useState(true);

  //typeProcessSelfie = 1 Indica que se pide primera la selfie y despues la captura de INE
  //typeProcessSelfie = 2 Indica que se captura de INE y despues selfie
  const typeProcessSelfie = location.state.typeProcessSelfie;
  const timeStamp = `${date.getFullYear()}${
    date.getMonth() + 1
  }${date.getDate()}${date.getHours()}${date.getMinutes()}${date.getSeconds()}`;
  const sectionId = location.state.sections.find((sec) => sec.Name === 'Selfie')?.Id;
  const sections = location.state.sections;
  const actorId = location.state.actorId;
  const metadataExtraccion = location.state.metadataExtraccion;

  const [autoloadSelfie, setAutoloadSelfie] = useState(false);
  const [latitude, setLatitude] = useState('-85.05112878');
  const [longitude, setLongitude] = useState('-180');
  const [loadSection, setLoadSection] = useState(false);
  const [loadFacial, setLoadFacial] = useState(false);

  const file = useSelector((state) => state.FileInfo);
  const uploadSecDoc = useSelector((state) => state.UploadSections);
  const facialResult = useSelector((state) => state.FacialComparison);
  const REDUX = useSelector((state) => state);
  const { t } = useTranslation();

  const typeSeflie = file?.items?.Stage?.Properties.find(
    (type) => type.Name == 'GetFaceCaptureNumber',
  );
  const typeAmbiente = file?.items?.Stage?.Properties.find(
    (type) => type.Name == 'ProofOfLifeValidationType',
  );
  const dispatch = useDispatch();
  console.log('.......................typeProcessSelfie,,,,,,,,,,,,,,....: ', typeProcessSelfie);
  console.log('REDUX', REDUX);
  const sentAleatorio = () => {
    let rand = Math.floor(valRandom * sentimientosArray.length);
    let rValue = sentimientosArray[rand];
    setValueSentimiento(rValue);
  };

  useEffect(() => {
    dispatch(documentsActions.CargaSeccion("", true));
    dispatch(documentsActions.GetFacialComparison("", true));
    dispatch(addTitleLegoCurrent('Captura de selfie'));
    sentAleatorio();
    let fileId = location.state.folioId;
    setFileId(fileId);
    // console.log("Folio ID: ", fileId)
    dispatch(fileActions.GetFileInfo(fileId));
    setLoadView(true);
    setActiveCargaInicial(true);
    setCurrentPicture(null);
    setArraySelfie([]);
    setCameraB64(null);
    localStorage.setItem('selfiePruebaVida', null);
  }, []);

  useEffect(() => {
    if (file.items != undefined && activeCargaInicial) {
      console.log('file.items: ', file.items);
      setLoadView(false);
      setActiveCargaInicial(false);
      setFileId(file.items.Id);
      if (typeProcessSelfie == 1) {
        const base64Image = localStorage.getItem('selfiePruebaVida');
        if (base64Image?.length > 4) {
          coreFunctions.GetRedirectStep(file, navigate);
        }
      }
    } else if (file?.error != undefined && activeCargaInicial) {
      setLoadView(false);
      setActiveCargaInicial(false);
    }
  }, [file]);

  console.log('typeSeflie', typeSeflie);

  useEffect(() => {
    if (cameraB64?.length > 0) {
      async function fetchData() {
        // console.log("request: ", dateFormat)
        let newArr = [...arraySelfie];
        newArr.push(cameraB64);
        // console.log("Selfie Carga: newArr: ", newArr)
        setArraySelfie(newArr);
        // AQUI ENTRA LA NUEVA CONTANTE PARA DETERMINAR EL USO DE LA NUEVA API
        if (typeAmbiente?.Value == '' || typeAmbiente?.Value == 'IDRND') {
          let request2 = {
            fileId: file.items.Id,
            uid: valueSentimiento?.uid,
            B64Data: `data:image/jpeg;base64,${cameraB64}`,
            fileName: `${timeStamp}.jpg`,
          };
          localStorage.setItem('selfiePruebaVida', null);
          localStorage.setItem('selfiePruebaVida', cameraB64);
          setLoadView(true);
          handleClear();

          let response2 = await documentsRequestsAsync.GetFaceDetectionIDRND(request2);
          if (response2 != null) {
            setValidateResponse(response2);
            // console.log("response2: ", response2)
          }
        } else {
          if (typeSeflie?.Value === '2') {
            if (arraySelfie.length == 0) {
              setLoadView(true);
              let request1 = {
                fileId: file.items.Id,
                B64Data: `data:image/jpeg;base64,${cameraB64}`,
                fileName: `${timeStamp}.jpg`,
              };
              handleClear();
              // setOpenInstruccion(true)
              localStorage.setItem('selfiePruebaVida', null);
              localStorage.setItem('selfiePruebaVida', cameraB64);
              console.log('request1: ', request1);
              let response1 = await documentsRequestsAsync.GetFaceDetection(request1);
              // console.log("response1: ", response1);
              if (response1) {
                setLoadView(false);
                setFaceResponse(response1);
              }
            } else if (arraySelfie.length === 1) {
              let request2 = {
                fileId: file.items.Id,
                uid: valueSentimiento?.uid,
                B64Data: `data:image/jpeg;base64,${cameraB64}`,
                fileName: `${timeStamp}.jpg`,
                faceDetectedId: faceResponse?.FaceDetectedId,
              };
              setCaptureInit(false);
              let response2 = await documentsRequestsAsync.GetFaceFeeling(request2);
              // console.log(response2)
              if (response2 != null) {
                //TODO: secomenta por pruebas
                setValidateResponse({
                  FeelingDetected: true,
                  FaceLiveAproved: true,
                });
                RegStatusStage(file.items.Id);
              }
            }
          } else {
            let request2 = {
              fileId: file.items.Id,
              uid: valueSentimiento?.uid,
              B64Data: `data:image/jpeg;base64,${cameraB64}`,
              fileName: `${timeStamp}.jpg`,
            };
            localStorage.setItem('selfiePruebaVida', null);
            localStorage.setItem('selfiePruebaVida', cameraB64);
            console.log('request2', request2);
            setLoadView(true);
            handleClear();
            let response2 = await documentsRequestsAsync.GetFaceFeeling(request2);
            if (response2 != null) {
              setValidateResponse(response2);
              RegStatusStage(file.items.Id);
              // console.log("response2: ", response2)
            }
          }
        }
      }
      fetchData();
    }
  }, [cameraB64]);

  const handleContinueAction = (e) => {
    // if (validateResponse?.FeelingDetected === true && validateResponse?.FaceCompareAproved === true) {
    if (
      (validateResponse?.FeelingDetected === true &&
        validateResponse?.FaceCompareAproved === true) ||
      validateResponse?.FaceLiveAproved === true
    ) {
      handleContinueClick();
      setTimeout(() => {
        setCameraB64(null);
        setDisabledButtonCapture(false);
        setOpenAlertInformation(false);
      }, 3000);
    } else {
      handleClear();
      setArraySelfie([]);
      setArraySelfie([]);
      sentAleatorio();
      setTimeout(() => {
        setValidateResponse(null);
        setCameraB64(null);
        setDisabledButtonCapture(false);
        setOpenAlertInformation(false);
      }, 6000);
    }
  };

  useEffect(() => {
    console.log('validateResponse', validateResponse);
    if (validateResponse?.FeelingDetected === true || validateResponse?.FaceLiveAproved === true) {
      handleContinueAction();
      setLoadView(false);
    } else if (
      validateResponse != undefined &&
      validateResponse != null &&
      validateResponse?.ResponseCode != '' &&
      validateResponse?.IsOK != true
    ) {
      console.log('validateResponse 0', validateResponse);
      handleContinueAction();
      setLoadView(false);
      setOpenAlertInformation(true);
    } else if (
      (validateResponse != undefined &&
        validateResponse != null &&
        validateResponse?.FeelingDetected != true) ||
      validateResponse?.FaceLiveAproved === false
    ) {
      handleContinueAction();
      setLoadView(false);
      setOpenAlertInformation(true);
    } else if (arraySelfie.length > 1) {
      setLoadView(true);
    }
  }, [arraySelfie, validateResponse]);

  useEffect(() => {
    if (timerSeconds == 0) {
      //Realiza la peticion
      setTimerSeconds(0);
    }
    // salir cuando lleguemos a 0
    if (!timerSeconds) return;

    // save intervalId para borrar el intervalo cuando el componente vuelve a renderizar
    const intervalId = setInterval(() => {
      setTimerSeconds(timerSeconds - 1);
    }, 1000);

    // clear interval al volver a renderizar para evitar pérdidas de memoria
    return () => clearInterval(intervalId);
  }, [timerSeconds]);

  useEffect(() => {
    if (autoloadSelfie) {
      const dataToSend = {
        // To UploadSection
        B64Content: cameraB64,
        FileId: file.items.Id,
        Actor_Id: actorId,
        SkipActor: null,
        SectionId: sectionId,
        Extension: '.jpg',
        Skip: false,
        SkipReason: null,
        Metadata: [
          {
            GroupName: 'FaceTec',
            Name: 'EnrollmentID',
            Value: `ObDS_${file.items.Id}_${timeStamp}`,
          },
        ],
        ContinueWorkFlow: false, //to upload all files before moving if true would move to the next stage
        Geolocation: {
          Latitude: latitude,
          Longitude: longitude,
        },
        DeferLoad: false, // heavy file, true to load on backgroud
      };
      console.log('sectionId----------send metadata-------------------: ', dataToSend);
      dispatch(documentsActions.CargaSeccion(dataToSend));
      setLoadSection(true);
    }
  }, [autoloadSelfie]);

  useEffect(() => {
    if (uploadSecDoc.items != undefined && loadSection) {
      console.log('uploadSecDoc.items****************************: ', uploadSecDoc.items);
      setLoadSection(false);
      setLoadFacial(true);
      localStorage.setItem('DocID', uploadSecDoc.items?.Result?.Id);

      if (uploadSecDoc.items.Result?.Id != null || uploadSecDoc.items.Result?.Id != undefined) {
        dispatch(documentsActions.GetFacialComparison(uploadSecDoc.items.Result.Id));
      }
    } else if (uploadSecDoc.error != undefined && loadSection) {
      setLoadSection(false);
      setLoadView(false);
      setAutoloadSelfie(false);
      RegStatusStage(file.items.Id, 'Inicializado');
      Alert(
        {
          icon: 'error',
          title: uploadSecDoc.error,
        },
        (event) => {
          coreFunctions.GetRedirectStep(file, navigate);
        },
      );
    }
  }, [uploadSecDoc]);

  useEffect(() => {
    if (facialResult.items != undefined && loadFacial) {
      setLoadView(false);
      setLoadFacial(false);
      //salta el carrusel y manda directo a ocr
      let folioId = file.items.Id;
      let docName = facialResult.items.Name;
      let documetId = facialResult.items.DocumentData.Id;
      let selfieMeta = facialResult.items.DocumentData.Metadata;
      let nextStage = file.items.Stage;
      let stage = file.items;

      const nextComponent = 'ExtractionForm';
      coreFunctions.DoNextStage({
        navigate,
        nextComponent,
        State: { stage, folioId, sections, docName, documetId, selfieMeta, metadataExtraccion },
      });
    } else if (facialResult.error != undefined && loadFacial) {
      setLoadView(false);
      setLoadFacial(false);
      setAutoloadSelfie(false);
      RegStatusStage(file.items.Id, 'Inicializado');
      Alert(
        {
          icon: 'error',
          title: facialResult.error,
        },
        (event) => {
          // window.location.reload(false)
          coreFunctions.GetRedirectStep(file, navigate);
        },
      );
      // window.location.reload(false);
    }
  }, [facialResult]);

  let handleCapture = () => {
    setDisabledButtonCapture(true);
    setCaptureInit(true);
  };

  const handleClear = () => {
    setCaptureInit(false);
    setCurrentPicture(null);
  };

  const handleContinueClick = () => {
    if (typeProcessSelfie == 1) {
      let nextStage = file.items.Stage;
      let stageName = nextStage.Name;
      let stageId = nextStage.Id;
      let folioId = file.items.Id;
      let stage = file.items;

      const nextComponent = 'IdentityValidationComponent';
      coreFunctions.DoNextStage({
        navigate,
        nextComponent,
        State: { stageName, stageId, stage, folioId },
      });
    } else {
      setAutoloadSelfie(true);
    }
  };

  const RegStatusStage = (folioId, statusValue = 'ValidaciónFacial') => {
    let request = {
      File_id: folioId,
      Status: statusValue, //"Captura"
    };
    dispatch(workflowActions.RegisterStatusStage(request));
  };

  //Comienza interfaz
  return (
    <GenericContainer
    isCameraComponent={true}
      sx={{
        paddingTop: '0px !important',
        position: 'relative',
        minHeight: '70vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden !important',
      }}
    >
      <Box
        sx={(theme) => ({
          position: 'relative',
          minHeight: '60vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          [theme.breakpoints.between(1200, 1535.95)]: {
            padding: '3px 0em',
          },
        })}
      >
        {/* Mask Container Siempre al Frente */}
        <Box
          className="mask-container"
          sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 2 }}
        />

        {/* Contenedor de Cámara */}
        <Box sx={{ position: 'relative', zIndex: 1 }}>
          {currentPicture === null && arraySelfie.length === 2 ? (
            <img alt="selfieImagen" src={`data:image/jpeg;base64,${cameraB64}`} />
          ) : typeSeflie?.Value === '1' && arraySelfie.length === 1 ? (
            <img alt="selfieImagen" src={`data:image/jpeg;base64,${cameraB64}`} />
          ) : currentPicture === null && !!cameraB64 ? (
            <img alt="selfieImagen" src={`data:image/jpeg;base64,${cameraB64}`} />
          ) : null}

          <CustomCameraSelfie
            isDisplay={currentPicture === null && cameraB64 === null ? true : false}
            onCapture={(blob) => {
              const reader = new FileReader();
              reader.readAsDataURL(blob);
              reader.onloadend = () => {
                setCameraB64(reader.result.replace('data:image/jpeg;base64,', ''));
                setCurrentPicture(URL.createObjectURL(blob));
              };
            }}
            Redimensionar={true}
            CaptureInit={captureInit}
          />
        </Box>

        {/* Botones siempre visibles */}
        <Box
          sx={{
            position: 'fixed',
            bottom: 20,
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            zIndex: 3,
            padding: '0 20em',
            ['@media only screen and (max-width: 812px)']: {
              padding: '0 10em',
            },
          }}
        >
          {!disabledButtonCapture &&
            (currentPicture === null ? (
              <Buttons ConfirmButtonText="Capturar" onClickConfirm={handleCapture} />
            ) : (
              <Buttons
                CancelButtonText="Recapturar"
                onClickCancel={handleClear}
                ConfirmButtonText="Continuar"
                onClickConfirm={() => console.log('CONTINUAR SELFIE')}
              />
            ))}
        </Box>

        {/* Alertas y Carga */}
        {openAlertInformation && (
          <CustomAlertDialog
            open={openAlertInformation}
            closeAction={() => {
              setCameraB64(null);
              setOpenAlertInformation(false);
            }}
            title={
              validateResponse?.FeelingDetected || validateResponse?.FaceLiveAproved
                ? 'Prueba de vida éxitosa'
                : 'No se pudo verificar tu prueba de vida'
            }
            Body={
              <Stack alignItems={'center'}>
                <Typography variant="h6" fontWeight={500}>
                  {validateResponse?.Message || 'Intenta nuevamente evitando sombras y reflejos'}
                </Typography>
              </Stack>
            }
            aceptedAction={handleContinueAction}
          />
        )}

        {openHelpSelfie && (
          <LifeTestHelp open={openHelpSelfie} closeAction={() => setOpenHelpSelfie(false)} />
        )}
        {loadView ||
          (autoloadSelfie && (
            <CustomLoadingOverlay
              active
              text={loadView ? 'Cargando...' : 'Extracción de datos...'}
            />
          ))}
      </Box>
    </GenericContainer>
  );
}
